import { WORDMARK_D, WORDMARK_W } from "./wordmarkPath";

export const STAR_D =
  "M50 2C52.6 33 58.5 46.5 96 52C58.5 55.6 52.6 67 50 98C47.4 67 41.5 55.6 4 52C41.5 46.5 47.4 33 50 2Z";

const VB_Y = -790;
const VB_H = 810;

/** Four-point signature star. `cut` adds the slanted notch from the symbol. */
export const Star = ({ className = "", color = "currentColor", cut = false, title, ...rest }) => (
  <svg viewBox="0 0 100 100" className={className} role={title ? "img" : "presentation"} aria-label={title} {...rest}>
    {cut && (
      <defs>
        <mask id="star-cut">
          <rect width="100" height="100" fill="white" />
          <path d="M44 46L56 58" stroke="black" strokeWidth="2.4" />
        </mask>
      </defs>
    )}
    <path d={STAR_D} fill={color} mask={cut ? "url(#star-cut)" : undefined} />
  </svg>
);

/** Primary STARVYNT™ wordmark (outlined, custom A). */
export const Wordmark = ({ className = "", color = "currentColor", tm = true, ...rest }) => (
  <svg viewBox={`-10 ${VB_Y} ${WORDMARK_W + (tm ? 360 : 20)} ${VB_H}`} className={className} role="img" aria-label="STARVYNT" {...rest}>
    <path d={WORDMARK_D} fill={color} />
    {tm && (
      <text x={WORDMARK_W + 50} y={-560} fill={color} fontFamily="Arial, sans-serif" fontSize="190" fontWeight="700">
        TM
      </text>
    )}
  </svg>
);

/** STARVYNT Creative Studio lockup: wordmark + spaced "CREATIVE STUDIO". */
export const Lockup = ({ className = "", color = "currentColor", accent = "#B794F6", ...rest }) => (
  <svg viewBox={`-10 ${VB_Y} ${WORDMARK_W + 360} ${VB_H + 520}`} className={className} role="img" aria-label="STARVYNT Creative Studio" {...rest}>
    <path d={WORDMARK_D} fill={color} />
    <text x={WORDMARK_W + 50} y={-560} fill={color} fontFamily="Arial, sans-serif" fontSize="190" fontWeight="700">TM</text>
    <text x="20" y="420" fill={accent} fontFamily="Sora, Arial, sans-serif" fontSize="300" fontWeight="400"
      textLength={WORDMARK_W - 40} lengthAdjust="spacing">
      CREATIVE STUDIO
    </text>
  </svg>
);

/** Simplified icon: star on a rounded square, for social avatars and favicon. */
export const Icon = ({ className = "", bg = "#0A0A0A", fg = "#B794F6", ...rest }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="STARVYNT Creative Studio icon" {...rest}>
    <rect width="64" height="64" rx="14" fill={bg} />
    <path transform="translate(8 6) scale(0.48 0.52)" d={STAR_D} fill={fg} />
  </svg>
);
